export default __webpack_public_path__ + "static/media/logo_top.9dc0bcd2.svg";